<template>
  <div class="about">
    <h1 class="header2">About OneFocus</h1>

    <div class="text">
      <p>OneFocus is a simple but focused application that allows students to work and study in a motivated, efficient and flexible manner.</p>
    </div>

    <div class="header2">Organize Tasks</div>

    <div class="text">
      <p> OneFocus provides a minimalistic task list that lets students organize their lives in a neat and aesthetic way. </p>
      <p>Tasks can be added with an estimated time-to-complete, attached with a particular goal or motivation that puts the task into perspective.</p>
      <p>Users can check off tasks when they are done and archive them to remove them from the list of tasks.</p>
    </div>

    <div class="header2">Track Goals</div>

    <div class="text">
      <p>With added support for keeping track of goals, students can keep their motivation in the long term while they create short term tasks. </p>
      <p>Keeping track of long term goals while using this app can help prevent students from losing focus on what they want to achieve.</p>
      <p>Progress of goals can be tracked through custom set 'units' of progress, and progress is displayed through a progress bar on each goal. These units of progress can correspond to days in a challenge (30 day diet challenge), number of assessments (get 5 A+'s), or anything else the student finds useful for their productivity.</p>
      <p>Once a goal is set, users can update their goals at any time, and archive them once they are completed.</p>
    </div>

    <div class="header2">Stay Focused with Pomodoro Timer</div>

    <div class="text pb-12">
      <p>A pomodoro timer can be accessed as well, which allows users to set intervals for focus, and for breaks. </p>
      <p>This gives users a more full-fledged and distraction less experience for their studies.</p>
      <p></p>
    </div>


  </div>
</template>

<style>

.about {
  height: 100vh;
}

</style>
